// @flow
import React from 'react'
import { Authors } from '../Authors'
import Lottie from 'react-lottie'
import headerAnimation from './images/header.json'
import headerImage from './images/header.png'
import './styles.scss'

const animationLightOptions = {
  loop: true,
  autoplay: true,
  animationData: headerAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

export class Header extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='header'>

      {/* Image Header */}
      <div className="header-image">
        <img src={headerImage} alt='header-image' />
        <Lottie
          options={animationLightOptions}
          isClickToPauseDisabled={true}
        />
      </div>
      {/* <img className='header-image' src={require(this.state.isMobile ? '../../images/header-mobile.png' : '../../images/header-desktop.png')} alt='header' /> */}
      
        <div className='title-wrapper'>
          <div className='titles'>
            <h1 dangerouslySetInnerHTML={{__html: this.state.isMobile ? this.props.titleMobile : this.props.title}}></h1>
          </div>
          <h2>{this.props.lead}</h2>
        </div>

        <div className="authors">
            <Authors authors={[
              {name: 'Patrick Meier', unityID:'19189591'},
              {name: 'Yannick Wiget', unityID:'28754714'},
              {name: 'Mathias Lutz', unityID:'95724327'},
            ]}
            tenant={this.props.tenant} />
            <div className='publication'>
            Publié le 6 mars 2023
          </div>
        </div>

    </div>
  }
}
